// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p6PCqZ4rVq0c7XZcnBXF{padding:34px 24px 0}.p6PCqZ4rVq0c7XZcnBXF .WjOmTOI2ArUBSE4CZB87{align-items:center;gap:8px;padding-bottom:16px;display:flex}.p6PCqZ4rVq0c7XZcnBXF .WjOmTOI2ArUBSE4CZB87 .s5Hw7JWUoPsYviWOXsQf{background:var(--black-20);border-radius:6px;justify-content:center;align-items:center;min-width:24px;height:24px;display:flex}.p6PCqZ4rVq0c7XZcnBXF .sY37D8PV2KQDFiO8C0ET{flex-direction:column;gap:8px;padding-top:24px;display:flex}.p6PCqZ4rVq0c7XZcnBXF .sY37D8PV2KQDFiO8C0ET .Jc33nsS7TOQa7lZre5LV{justify-content:flex-start;align-items:center;gap:80px;display:flex}.p6PCqZ4rVq0c7XZcnBXF .sY37D8PV2KQDFiO8C0ET .Jc33nsS7TOQa7lZre5LV .XSxOcLYxX1wVAEfSPsj6{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `p6PCqZ4rVq0c7XZcnBXF`,
	"titleWrap": `WjOmTOI2ArUBSE4CZB87`,
	"stepBox": `s5Hw7JWUoPsYviWOXsQf`,
	"sendInfo": `sY37D8PV2KQDFiO8C0ET`,
	"scheduleWrap": `Jc33nsS7TOQa7lZre5LV`,
	"value": `XSxOcLYxX1wVAEfSPsj6`
};
export default ___CSS_LOADER_EXPORT___;
